import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Initialize once (the heavy part)
const fpPromise = FingerprintJS.load();

export async function getVisitorId() {
  const fp = await fpPromise;
  const result = await fp.get();

  return {
    components: FingerprintJS.componentsToDebugString(result.components),
    visitorId: result.visitorId,
  }; // has visitorId + components
}
